import styled from 'styled-components';
import { cn } from '@shadcn/lib/utils';

export const AmbossOverlay = styled.div.attrs({
  className: 'fixed inset-x-0 z-50 animate-in fade-in slide-in-from-top-2 duration-200 ease-out',
})``;

export const AmbossEmbedFrame = styled.div.attrs({
  className: 'fixed inset-x-0 bottom-0 z-50 bg-background',
})``;

export const AmbossHistoryOverlay = styled.div.attrs({
  className:
    'fixed inset-x-0 bottom-0 z-50 animate-in fade-in slide-in-from-top-2 duration-200 ease-out bg-card',
})``;

export const AmbossPanel = styled.div.attrs({
  className: 'w-full rounded-b-lg border-b border-border bg-card p-4 shadow-md',
})``;

export const AmbossActionBar = styled.div.attrs({
  className: 'flex shrink-0 items-center gap-2 text-vantis-violet',
})``;

export const AmbossIconButton = styled.button.attrs<{ $active?: boolean }>((props) => ({
  type: 'button',
  className: cn(
    'flex h-8 w-8 shrink-0 cursor-pointer items-center justify-center rounded-md hover:bg-muted',
    props.$active && 'bg-muted'
  ),
}))<{ $active?: boolean }>``;

export const AmbossPanelTitle = styled.p.attrs({
  className: 'truncate text-base font-medium text-foreground',
})``;
